// extracted by mini-css-extract-plugin
module.exports =  {"nav-button":"l2zL_z2","navButton":"l2zL_z2"};